/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1ExamIdMutationRequest,
  PutApiV1ExamIdMutationResponse,
  PutApiV1ExamIdPathParams,
  PutApiV1ExamId400,
  PutApiV1ExamId401,
  PutApiV1ExamId404,
  PutApiV1ExamId500,
} from "../../types/examEvaluationController/PutApiV1ExamId.ts";

function getPutApiV1ExamIdUrl(id: PutApiV1ExamIdPathParams["id"]) {
  const res = { method: "PUT", url: `/api/v1/exam/${id}` as const };
  return res;
}

/**
 * @description Atualiza os dados de uma prova existente. A alteração do tipo de prova só é permitida entre os tipos Avaliação do Aluno e Qualificação quando não há idiomas associados com tipo inválido. A edição é bloqueada quando já existem tentativas registradas. **(Requer Authorization para autenticação)**
 * @summary Editar prova (Requer Authorization para autenticação)
 * {@link /api/v1/exam/:id}
 */
export async function putApiV1ExamId(
  id: PutApiV1ExamIdPathParams["id"],
  data?: PutApiV1ExamIdMutationRequest,
  config: Partial<RequestConfig<PutApiV1ExamIdMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1ExamIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1ExamId400
      | PutApiV1ExamId401
      | PutApiV1ExamId404
      | PutApiV1ExamId500
    >,
    PutApiV1ExamIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1ExamIdUrl(id).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
